class AuthenticationFrontendWithPhoneExpiredCodeApiException extends Error {
}

export {
    AuthenticationFrontendWithPhoneExpiredCodeApiException
}
